import { useEffect, useState } from 'react';
import { User } from './types/User';
import Tabs from '../Tabs';
import {
    fetchCampaignsOfUser,
    fetchCampaignRequestsOfUser,
    fetchInitialCampaignRequestsOfUser,
} from '~/services/users';
import CampaignTable from './tables/CampaignTable';
import CampaignRequestTable from './tables/CampaignRequestTable';
interface Props {
    user: User;
}

const ClientTabs: React.FC<Props> = ({ user }) => {
    const [openTab, setOpenTab] = useState(1);
    const [campaigns, setCampaigns] = useState<any[]>([]);
    const [campaignRequests, setCampaignRequests] = useState<any[]>([]);
    const [initialCampaigns, setInitialCampaigns] = useState<any[]>([]);
    const [initialCampaignsCount, setInitialCampaignsCount] = useState(0);
    
    // Pagination state for campaigns
    const [campaignsPage, setCampaignsPage] = useState(1);
    const [campaignsPages, setCampaignsPages] = useState(1);
    const [campaignsTotalCount, setCampaignsTotalCount] = useState<number | undefined>(undefined);

    // Dynamic tabs with actual counts
    const tabs = [
        { name: 'Campaigns as Client', count: campaigns.length },
        { name: 'Campaign Requests as Initial Contact', count: initialCampaignsCount },
        { name: 'Campaign Requests as Team Member', count: campaignRequests.length },
    ];

    const fetchAndSetCampaignRequest = async () => {
        const campaignRequestResponse = await fetchCampaignRequestsOfUser({
            user_id: user?.id,
        });
        setCampaignRequests(campaignRequestResponse.results || []);
    };

    const fetchAndSetInitialCampaign = async () => {
        const initialCampaignResponse =
            await fetchInitialCampaignRequestsOfUser({ user_id: user?.id });
        setInitialCampaigns(initialCampaignResponse.results || []);
        setInitialCampaignsCount(initialCampaignResponse.count || 0);
    };

    const fetchAndSetCampaign = async () => {
        const campaignResponse = await fetchCampaignsOfUser({
            user_id: user?.id,
        });
        setCampaigns(campaignResponse.results || []);
        // Calculate pages based on results (assuming 10 per page)
        const totalCount = campaignResponse.count || campaignResponse.results?.length || 0;
        setCampaignsTotalCount(totalCount);
        setCampaignsPages(Math.max(1, Math.ceil(totalCount / 10)));
    };
    
    useEffect(() => {
        if (user?.id) {
            fetchAndSetCampaign();
            fetchAndSetCampaignRequest();
            fetchAndSetInitialCampaign();
        }
    }, [user?.id]);

    return (
        <>
            <Tabs tabNames={tabs} openTab={openTab} setOpenTab={setOpenTab}>
                {openTab == 1 && (
                    <CampaignTable
                        campaigns={campaigns}
                        page={campaignsPage}
                        setPage={setCampaignsPage}
                        pages={campaignsPages}
                        totalCount={campaignsTotalCount}
                    />
                )}
                {openTab == 2 && (
                    <CampaignRequestTable campaigns={initialCampaigns} />
                )}
                {openTab == 3 && (
                    <CampaignRequestTable campaigns={campaignRequests} />
                )}
            </Tabs>
        </>
    );
};

export default ClientTabs;
